<template>
  <div>
    <editor-stepper
    />
    <loader v-if="loading"
      :label="$t('compatibleScenarios.searching')"
    />
    <v-container
      v-else
      class="py-0"
      fluid
    >
        <v-toolbar
          class="ma-6 elevation-0"
          color="#E0F2F1"
        >
          <template>
            <v-btn
              class="raison-btn"
              @click="addUnion()"
            >
              <v-icon>mdi-plus</v-icon>
              {{ $t('compatibleScenarios.combine') }}
            </v-btn>
            <v-spacer/>
            <span v-if="combinations.length > 0">
              <v-btn
                v-if="debugMode && panel.length < combinations.length"
                fab
                small
                class="raison-btn ma-2"
                @click="all"
              >
                <v-icon>mdi-expand-all</v-icon>
              </v-btn>
              <v-btn
                v-if="debugMode && panel.length > 0"
                class="raison-btn ma-2" 
                fab
                small
                @click="none"
              >
                <v-icon>mdi-collapse-all</v-icon>
              </v-btn>
            </span>
          </template>
        </v-toolbar>


        <v-expansion-panels
          v-model="panel"
          multiple
        >
          <v-expansion-panel
            v-for="(union,i) in combinations"
            :key="i"
            :readonly="!debugMode"
          >
            <v-expansion-panel-header
              :hide-actions="!debugMode"
            >
              <v-row align="center">
                <v-btn fab x-small class="raison-btn mx-4" @click.native.stop="updateUnion(union)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <div>
                  <v-chip :color="color(union.id)" small class="ma-1">{{ debugMode ? union.id : '' }}</v-chip>
                </div>
                <div>
                  <scenario
                  v-if="!panel.includes(i)"
                  :scenario="unionAsScenario(union)"
                  :show-details="false"
                  >
                  </scenario>
                </div>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <scenario
                v-for="(scenario,s) in union.scenarios"
                :key="s"
                :scenario="scenario"
                :show-details="debugMode"
              >
              </scenario>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>


        <v-row v-if="totalNumberOfItems > 0">
          <v-col>
            <v-row
              class="mt-2"
              align="center"
              justify="center"
            >
              <span class="grey--text caption">{{ $t('global.rowPerPage') }}</span>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    dark
                    text
                    color="grey"
                    class="ml-2 caption"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ itemsPerPage }}
                    <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(number, index) in itemsPerPageArray"
                    :key="index"
                    @click="updateItemsPerPage(number)"
                  >
                    <v-list-item-title>{{ number }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <span
                class="mr-4 grey--text caption"
              >
                {{ legend }}
              </span>
              <v-btn
                fab
                dark
                color="#062b89"
                class="mr-1"
                @click="formerPage"
                small
                :disabled="isFirstPage"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn
                fab
                dark
                color="#062b89"
                class="ml-1"
                @click="nextPage"
                small
                :disabled="isLastPage"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

    </v-container>
    <identify-compatible-scenarios-dialog
      :open.sync="openIdentifyCompatibleScenariosDialog"
      :combination="selectedCombination"
      @scenariosCombinationCreated="onScenariosCombinationCreated"
      @scenariosCombinationUpdated="onScenariosCombinationUpdated"
      @scenariosCombinationDeleted="onScenariosCombinationDeleted"
    />
  </div>
</template>
<script>
import EditorStepper from '@/components/editor/EditorStepper'
import IdentifyCompatibleScenariosDialog from '@/components/identifyCompatibleScenarios/IdentifyCompatibleScenariosDialog'
import Loader from '@/components/global/Loader'
import Scenario from '@/components/global/Scenario'

import pageableMixin from '@/mixins/pageable-mixin.js'
import debugModeMixin from '@/mixins/debug-mode-mixin.js'

import helpService from '@/services/help.js'
import scenarioService from '@/services/scenarios.js'

export default {
  name: 'ListCompatibleScenarios',

  components: {
    EditorStepper,
    IdentifyCompatibleScenariosDialog,
    Loader,
    Scenario,
  },

  mixins: [ debugModeMixin, pageableMixin ],

  data () {
    return {
      loading: true,
      combinations: [],
      selectedCombination: {},
      panel: [],
      openIdentifyCompatibleScenariosDialog: false
    };
  },

  props: {
  },

  computed: {
    debugMode() {
      if(!this.$store.state.debugMode) {
        this.none()
      }
      return this.$store.state.debugMode
    },
  },

  methods: {
    onScenariosCombinationDeleted(union) {
      const index = this.combinations.findIndex(combination => combination.id === union.id)
      if(index != -1) {
        this.combinations.splice(index, 1)
      }
    },
    onScenariosCombinationUpdated(union) {
      console.log('onScenariosCombinationUpdated', union)
      const index = this.combinations.findIndex(combination => combination.id === union.id)
      if(index != -1) {
        this.combinations.splice(index, 1, union)
      }
    },
    onScenariosCombinationCreated(union) {
      this.combinations.splice(0, 0, union)
    },
    color(unionId) {
      return scenarioService.mapColor(unionId)
    },
    addUnion() {
      this.selectedCombination = {} // none
      this.openIdentifyCompatibleScenariosDialog = true
    },
    updateUnion(union) {
      // console.log('updateUnion', union.id)
      this.selectedCombination = union
      this.openIdentifyCompatibleScenariosDialog = true
    },
    deleteUnion(union) {
      const projectId = this.$route.params.id
      scenarioService.deleteCompatibleScenariosUnion(projectId, union.id)
        .then(() => {
            const index = this.combinations.indexOf(union)
            this.combinations.splice(index, 1)
            this.totalNumberOfItems--
          })
          .catch(err => {
            this.$emit('raison-event', { type: 'error', messages: [err] })
          })
          .finally(() => {
            this.loading = false
          })
    },
    unionAsScenario(scenarios) {
      return scenarioService.unionAsScenario(scenarios)
    },
    // Create an array the length of our items
    // with all values as true
    all () {
      this.panel = [...Array(this.combinations.length).keys()].map((k, i) => i)
    },
    // Reset the panel
    none () {
      this.panel = []
    },
    findCompatibleScenarios() {
      this.loading = true
      const projectId = this.$route.params.id

      scenarioService.findCompatibleScenarios(projectId, this.page, this.itemsPerPage)
        .then(response => {
          this.combinations = response.data.content
          this.page = response.data.page.number + 1
          this.numberOfPages = response.data.page.totalPages
          this.isLastPage = response.data.page.last
          this.totalNumberOfItems = response.data.page.totalElements
        })
        .catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err] })
        })
        .finally(() => {
          this.loading = false
        })
    },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) {
        this.page += 1
        this.findCompatibleScenarios()
      }
    },
    formerPage() {
      if (this.page - 1 >= 1) {
        this.page -= 1
        this.findCompatibleScenarios()
      }
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number
      this.page = 1
      this.findCompatibleScenarios()
    },
  },

  created () {
    this.findCompatibleScenarios()
    helpService.setHelpPage(this.$store, 'editor_compatible_scenarios')
  }
}
</script>
<style scoped>
.rai-selectable-scenario {
  cursor: pointer;
}
</style>